import { keyframes } from "styled-components";

export const fadeIn = keyframes`
  0% {opacity:0;}
  100% {opacity:1;}
`;

export const blink = keyframes`
  50% {opacity: 0.48;}
`;
